import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment.development";
import { constantvalues } from "../../../const";
import { Observable } from "rxjs";
@Injectable({
    providedIn: 'root'
})

export class SendBulkEmailService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getAllMatAdminMailIds(sectorId: number) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_MAT_ADMIN_MAILIDS}/${sectorId}`);
    }

    getAllSchoolAdminMailIds() {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_SCHOOL_ADMIN_MAILIDS}`);
    }

    sendBulkEmail(emailIds: string[], content: string): Observable<boolean> {
        const payload = {
            emailIds: emailIds,
            content: content
        };
        return this.httpClient.post<boolean>(`${this.baseURL}${constantvalues.API_URL.SEND_BULK_EMAIL}`, payload);
    }

}